let appStore = null;

export const setStore = (store) => {
  appStore = store;
};

export const getAppStore = () => {
  if (!appStore) {
    throw new Error('Store has not been initialized yet!');
  }
  return appStore;
};
